import { FlagsDashboardTemplate } from "app/features/statusFlags/templates/FlagsDashboardTemplate";

export default function StatusFlagsScreen() {
  return <FlagsDashboardTemplate />;
}
